import * as React from 'react'

interface ArrowProps {
  className?: string
}

const Arrow = ({ className }: ArrowProps): JSX.Element => {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="none">
        <mask
          id="mask0_4691_1518"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="25"
        >
          <rect x="0.5" y="0.599609" width="24" height="24" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_4691_1518)">
          <path
            d="M16.675 13.5996H4.5V11.5996H16.675L11.075 5.99961L12.5 4.59961L20.5 12.5996L12.5 20.5996L11.075 19.1996L16.675 13.5996Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  )
}
export default Arrow
